// Centralized API configuration
// This allows easy switching between development and production environments

const getApiBaseUrl = (): string => {
  // Check for environment variable first (for production)
  const apiUrl = process.env.REACT_APP_API_URL;
  
  if (apiUrl) {
    // Remove trailing slash if present
    return apiUrl.replace(/\/$/, '');
  }
  
  // Fallback to localhost for development
  // In production (Netlify), this should never be used if REACT_APP_API_URL is set
  if (process.env.NODE_ENV === 'production') {
    console.error('❌ REACT_APP_API_URL not set in production! This will cause connection errors.');
  } else {
    console.warn(
      '⚠️ REACT_APP_API_URL not set! Using local startup-project default (localhost:8080). Set .env.development or .env.production.'
    );
  }
  // Default when REACT_APP_API_URL is unset — matches ../startup-project (server.port=8080)
  return 'http://localhost:8080';
};

export const API_BASE_URL = getApiBaseUrl();
export const API_URL = `${API_BASE_URL}/api`;

// Export individual endpoint base URLs for convenience
export const API_ENDPOINTS = {
  AUTH: `${API_URL}/auth`,
  BUSINESS: `${API_URL}/businesses`,
  VENDOR: `${API_URL}/vendors`,
  DISH: `${API_URL}/dishes`,
  THEME: `${API_URL}/themes`,
  INVENTORY: `${API_URL}/inventory`,
  PLATE: `${API_URL}/plates`,
  ORDER: `${API_URL}/orders`,
  CHAT: `${API_URL}/chat`,
  NOTIFICATION: `${API_URL}/notifications`,
  RATING: `${API_URL}/ratings`,
  AVAILABILITY: `${API_URL}/availability`,
  IMAGE: `${API_URL}/images`,
  USER: `${API_URL}/users`,
};

export default API_BASE_URL;

